/* eslint-disable no-unused-vars,no-bitwise,no-continue,no-plusplus */

import $ from 'jquery';
import _ from 'lodash';
import liveSettings from './live-settings.json';
import testSettings from './test-settings.json';
import { getAdminAction } from '../utilities/utilities';
import { selectCurrentPagePath } from '../../ReduxStorage/Pages/selectors';
import { selectCurrentInstitution } from '../../ReduxStorage/Institutions/selectors';
import { selectCurrentPortal } from '../../ReduxStorage/Portal/selectors';
import {
  selectCurrentCourseSubscriptionId,
  selectIsInCourse,
} from '../../ReduxStorage/Courses/selectors';
import { AnalyticsGroupType } from '../metrics/types';
import { NO_SUBSCRIPTION } from '../metrics/constants';

const LEGACY_NAME_MAPPING = {
  'widget-edit': 'Widget-Edited',
  'widget-store': 'WidgetStores-Edited',
  'widget-complete': 'Widget-Completed',
  'widget-progress': 'Widget-Progressed',
  'widget-interacted': 'Widget-Interacted',
  'comment-like': 'UpVote-Made',
  'comment-post': 'Comment-Made',
  'share-post': 'Post-Made',
  'share-start': 'PostButton-Clicked',
  'comment-dislike': 'DownVote-Made',
  'comment-delete': 'Comment-Deleted',
  'conversation-open': 'ChatChannel-Opened',
  'conversation-first-open': 'ChatChannel-Opened',
  'conversation-first-post': 'ChatMessage-Posted',
  'conversation-post': 'ChatMessage-Posted',
  'comment-feature': 'Comment-Feature',
  'comment-unfeature': 'Comment-Unfeature',
  'page-create': 'Page-Created',
  'page-edit': 'Page-Edited',
  'page-save': 'Page-Edited',
  'page-update-layout': 'Page-Edited',
  'page-create-user-data': 'Page-Edited',
  'page-layout': 'Page-Edited',
  'page-add-block': 'Widget-Added',
  'comment-post-error': 'ErrorComment-Posted',
  'page-leave': 'Page-Leave',
  'page-scroll': 'Page-Scroll',
  'page-click': 'Page-Click',
  'page-load': 'Page-Load',
};

const EVENT_TYPES = new Set([
  /*
  'Widget-Edited',
  'WidgetStores-Edited',
  'Widget-Completed',
  'Widget-Progressed',
  'Widget-Interacted',
  */
  'UpVote-Made',
  'Comment-Made',
  'Post-Made',
  'PostButton-Clicked',
  'DownVote-Made',
  'Comment-Deleted',
  'ChatChannel-Opened',
  'ChatMessage-Posted',
  'Comment-Feature',
  'Comment-Unfeature',
  'Course-Searched',
  'Page-Created',
  'Page-Edited',
  'Post-Viewed',
  'Widget-Added',
  'ErrorComment-Posted',
  'Filter-Selected',
  //  'Page-Leave',
  //  'Page-Scroll',
  //  'Page-Click',
  'Page-Load',
  'Page-Navigated',
  'Page-Subscribed',
  'Module-Created',
  'Module-Edited',
  'PageInstitutionLanding-Viewed',
  'PageQualificationLanding-Viewed',
  'PageCourseLanding-Viewed',
  'ProfileImage-Updated',
  'MarketingVideo-Played',
  'LearnSubject-Requested',
  'FAQ-Viewed',
  'CTAButton-Clicked',
  'LoginModal-Opened',
  'Qualification-Enrolled',
  'EnrolmentEmail-Triggered',
  'GetCertifiedButton-Clicked',
  'Assessment-Requested',
  'WalkThrough-Clicked',
  'WalkThrough-Hid',
  'CourseIntroModal-Viewed',
  'NotificationMenu-Viewed',
  'Notification-Viewed',
  'FindOutMoreAboutCourse-Clicked',
  'GACertificate-Purchased',
  'GACourse-Purchased',
  'GAAccount-Created',
  'GACourse-EnrolledForFree',
  'GASubscription-Purchased',
  'GAInvoice-Requested',
  'PortfolioPost-Clicked',
  'Portfolio-Changed',
  'Portfolio-Viewed',
  'ProfileChanged',
  'ProfileMessage-Sent',
  'ProfileLink-Shared',
  'UpgradePrompt-Viewed',
  'PaymentPage-Viewed',
  'ContentEditorWalkthrough-Clicked',
  'ContentEditorDiagram-Clicked',
  'EducatorOnBoardingVideo-Closed',
  'EducatorOnBoardingVideo-Played',
  'EducatorOnBoardingVideo-PassTimestamp',
  'EducatorOnBoardingVideo-Ended',
  'Studentdata-Viewed',
  'Studentdata-Exported',
  'Studentdata-Downloaded',
  'StartTrialButton-Clicked',
  'CourseDiscoveryFilter-Applied',
  'BlogPost-Made',
  'PageTemplate-Previewed',
  'PageTemplate-Chosen',
  'PageTemplate-Used',
  'Institution-Created',
  'Institution-TurnedOnline',
  'CourseOutcomes-Saved',
  'CourseLandingPage-Saved',
]);

const collapseKeys = (obj, sep, startingDepth) => {
  const collapsed = {};

  const _collapseKeys = (currentKey, currentObj, depth) => {
    Object.keys(currentObj).forEach((key) => {
      const newKey = currentKey ? `${currentKey}${sep}${key}` : key;
      const val = currentObj[key];
      const isLimited = depth !== null && depth <= 0;
      const isObject =
        Object.prototype.toString.call(val) === '[object Object]';

      if (isObject && !isLimited) {
        _collapseKeys(newKey, val, depth - 1);
      } else {
        collapsed[newKey] = val;
      }
    });
  };

  _collapseKeys(null, obj, startingDepth);

  return collapsed;
};
const collapseProperty = (state, property, sep, depth) => {
  const collapsed = collapseKeys(
    {
      [property]: state[property],
    },
    sep,
    depth
  );

  Object.assign(state, collapsed);
};

export class SiteData {
  static uuid(ph) {
    return ph // if the placeholder was passed, return a random number from 0 to 15
      ? (ph ^ ((Math.random() * 16) >> (ph / 4))).toString(16)
      : // -80000000 +
        (
          [1e7] + // 10000000 +
          -1e3 + // -1000 +
          -4e3 + // -4000 +
          -8e3 +
          -1e11
        ) // -100000000000,
          .replace(
            // replacing
            /[018]/g, // zeroes, ones, and eights with
            SiteData.uuid // random hex digits
          );
  }

  static getElementXPath(elt) {
    if (!elt) {
      return undefined;
    }

    if (elt.id) {
      return `//*[@id="${elt.id}"]`;
    } else {
      const paths = [];

      // Use nodeName (instead of localName) so namespace prefix is included (if any).
      for (
        let element = elt;
        element && element.nodeType === 1;
        element = element.parentNode
      ) {
        let index = 0;
        // EXTRA TEST FOR ELEMENT.ID
        if (element && element.id) {
          paths.unshift(`/*[@id="${element.id}"]`);
          break;
        }

        for (
          let sibling = element.previousSibling;
          sibling;
          sibling = sibling.previousSibling
        ) {
          // Ignore document type declaration.
          if (sibling.nodeType === Node.DOCUMENT_TYPE_NODE) {
            continue;
          }

          if (sibling.nodeName === element.nodeName) {
            index += 1;
          }
        }

        const tagName = element.nodeName.toLowerCase();
        const pathIndex = index ? `[${index + 1}]` : '';
        paths.unshift(tagName + pathIndex);
      }

      return paths.length ? `/${paths.join('/')}` : null;
    }
  }

  init = (loadedData) => (dispatch) => {
    this.dispatch = dispatch;
    this.numClicks = 0;
    this.numKeysPressed = 0;
    this.scrollDepth = 0;
    this.scrollDistance = 0;
    this.scrollDirection = 0;
    this.lastScrollNode = {
      position: 0,
      timestamp: Date.now(),
    };

    this.isTouchCapable =
      'ontouchstart' in document || 'onpointerdown' in document;
    this.remoteAddress = loadedData['remote-address'];
    this.pageSessionId = SiteData.uuid();

    this.state = loadedData;

    this.loadTime = Date.now();

    this.inactiveTime = 0;

    this.lastBlurTime = null;

    this.logQueue = [];

    this.isMessagingReady = false;

    // break circular dependency
    import('../chat/src/userMessaging').then(() => {
      $.userMessaging.ready(() => {
        this.isMessagingReady = true;
      });
    });

    if (_BUILD_TYPE === 'live') {
      this.analyticsURL = liveSettings['analytics-url'];
    } else {
      this.analyticsURL = testSettings['analytics-url'];
    }

    // TODO use capture mode: addEventListener(name, cb, true)
    $(document).on('scroll', this.onScroll);
    $(document).on('keypress', this.onKeyPress); // TODO this event is deprecated
    $(document).on('click', this.onClick);

    $(window).on('focus', this.pageFocus).on('blur', this.pageBlur);
  };

  onScroll = () => {
    requestAnimationFrame(() => {
      // evt
      const timestamp = Date.now();
      const scrollTop = $(window).scrollTop();
      const scrollDelta = scrollTop - this.lastScrollNode.position;
      const scrollDirection = scrollDelta / Math.abs(scrollDelta);
      const timeDelta = timestamp - this.lastScrollNode.timestamp;
      const isTimedOut = timeDelta > 1000;

      this.scrollDepth = Math.max(this.scrollDistance, scrollTop);
      this.scrollDistance += Math.abs(scrollDelta);

      if (isTimedOut) {
        this.dispatch(
          this.logEvent('page-scroll', {
            lastScrollNode: this.lastScrollNode,
          })
        );
      }

      this.lastScrollNode = {
        position: scrollTop,
        timestamp,
      };

      if (this.scrollDirection !== scrollDirection || isTimedOut) {
        // point of inflection
        this.dispatch(
          this.logEvent('page-scroll', {
            lastScrollNode: this.lastScrollNode,
          })
        );
      }

      this.scrollDirection = scrollDirection;
    });
  };

  onKeyPress = () => {
    this.numKeysPressed++;
  };

  onClick = (evt) => {
    requestAnimationFrame(() => {
      this.numClicks++;
      this.dispatch(
        this.logEvent('page-click', {
          element: SiteData.getElementXPath(evt.target),
          x: evt.pageX,
          y: evt.pageY,
          timestamp: evt.timestamp,
          width: $(window).width(),
          height: $(window).height(),
        })
      );
    });
  };

  destroy = () => {
    $(window).off('blur', this.pageBlur);
    $(window).off('focus', this.pageFocus);
    $(document).off('scroll', this.onScroll);
    $(document).off('keypress', this.onKeyPress);
    $(document).off('click', this.onClick);
  };

  pageLoad = () => (dispatch) =>
    dispatch(
      this.logEvent('page-load', {
        adminAction: getAdminAction(),
      })
    );

  pageLeave = () => (dispatch) =>
    dispatch(this.logEvent('page-leave', {}, true));

  pageBlur = () => {
    this.lastBlurTime = Date.now();
  };

  pageFocus = () => {
    const focusTime = Date.now();

    if (this.lastBlurTime !== null) {
      this.inactiveTime += focusTime - this.lastBlurTime;
    }

    this.lastBlurTime = null;
  };

  identify(userId, traits, options) {
    if (userId) {
      this.state['user-id'] = userId;
    }

    if (window.amplitude && this.state['user-id']) {
      const { amplitude } = window;
      amplitude.getInstance().setUserId(userId);

      const identify = new amplitude.Identify();

      if (traits) {
        Object.entries(traits).forEach(([key, value]) => {
          identify.set(key, value);
        });
      }

      amplitude.getInstance().identify(identify);
    }
  }

  getPresence() {
    if (!this.isMessagingReady) {
      return {};
    }

    const presence = {
      'num-online': $.userMessaging.getNumOnline(),
    };

    if (this.state['cohort-path']) {
      presence['num-class-online'] = $.userMessaging.getNumOnline(
        this.state['cohort-path']
      );
    }

    return presence;
  }

  getAnalyticsState = (eventName, interactionData) => (dispatch, getState) => {
    const now = Date.now();

    const currentPagePath = selectCurrentPagePath(getState());
    const currentInstitution = selectCurrentInstitution(getState());
    const currentInstitutionPortal = selectCurrentPortal(getState());
    const isLowCostInstitution =
      currentInstitution && currentInstitutionPortal?.get('lowCost', false);

    const totalTime = now - this.loadTime;

    const windowSize = {
      width: $(window).width(),
      height: $(window).height(),
    };

    let mem = {};

    if (window.performance && window.performance.memory) {
      mem = {
        jsHeapSizeLimit: window.performance.memory.jsHeapSizeLimit,
        totalJSHeapSize: window.performance.memory.totalJSHeapSize,
        usedJSHeapSize: window.performance.memory.usedJSHeapSize,
      };
    }

    let presence;

    try {
      presence = this.getPresence();
    } catch (err) {
      presence = null;
    }

    const outputState = {
      'user-id': this.state['user-id'],
      isAdminOfCourse: this.state.isCourseAdmin,
      _token: this.state._token,
      presence,
      browsing: {
        'page-location': window.location.href,
        'page-path': currentPagePath,
        'page-session-id': this.pageSessionId,
        'active-time': totalTime - this.inactiveTime, // time spent on current page doing stuff
        'inactive-time': this.inactiveTime, // time spent on current page blurred
        'total-time': totalTime,
        'scroll-position': $(window).scrollTop(),
        'scroll-distance': this.scrollDistance,
        'scroll-depth': this.scrollDepth,
        'num-clicks': this.numClicks,
        'num-keypress': this.numKeysPressed,
      },
      client: {
        'touch-capable': this.isTouchCapable,
        'remote-addr': this.remoteAddress,
        hostname: window.location.host,
        platform: window.navigator.platform,
        'user-agent': window.navigator.userAgent,
        language: window.navigator.language || window.navigator.systemLanguage,
        window: windowSize,
      },
      performance: {
        timing: window.performance && window.performance.timing,
        memory: mem,
      },

      // compulsory
      cohort: this.id,
      event: eventName,
      interaction: interactionData,
      // low cost institution flag
      isLowCostInstitution,
    };

    collapseProperty(outputState, 'interaction', '__', 1);

    if (this.state['cohort-type'] === 'class') {
      outputState.class = {
        id: this.state.cohort,
        path: this.state['cohort-path'],
      };
    }

    return outputState;
  };

  logEvent = (
    eventName,
    interactionData = {},
    immediate = false,
    options = {}
  ) => (dispatch, getState) => {
    const logData = dispatch(
      this.getAnalyticsState(eventName, interactionData)
    );
    // if log event call is under a low cost institution then skip it
    if (logData.isLowCostInstitution) {
      return logData;
    }

    const legacyEventName = LEGACY_NAME_MAPPING[eventName] || eventName;
    logData.event = legacyEventName;
    if (!options) {
      options = {}; // eslint-disable-line no-param-reassign
    }

    if (EVENT_TYPES.has(legacyEventName) && window.amplitude) {
      const { amplitude } = window;
      const state = getState();
      const subscriptionId = selectIsInCourse(state)
        ? selectCurrentCourseSubscriptionId(state)
        : null;

      amplitude
        .getInstance()
        .setGroup(
          AnalyticsGroupType.Subscription,
          subscriptionId || NO_SUBSCRIPTION
        );

      amplitude.getInstance().logEvent(legacyEventName, logData);
    }

    return logData;
  };

  get id() {
    return `${this.state['cohort-type']}-${this.state.cohort}`;
  }
}
